import React, { useState } from 'react';
import { formatHour, segmentStyle } from '../utils/scheduleUtils';

const ScheduleAvailabilityBlock = ({
  segment,
  isDragging,
  onMoveStart,
  onResizeStart,
  onDeleteRequest,
}) => {
  const [hovered, setHovered] = useState(false);

  if (isDragging) {
    return null;
  }

  return (
    <div
      className={`schedule-availability-block${hovered ? ' is-hovered' : ''}`}
      style={segmentStyle(segment.startHour, segment.endHour)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div
        className="schedule-resize-handle schedule-resize-handle--top"
        title="Изменить начало"
        onMouseDown={(e) => onResizeStart(e, segment, 'resize-start')}
      />

      <div
        className="schedule-availability-body"
        onMouseDown={(e) => onMoveStart(e, segment)}
      >
        <span className="schedule-availability-label">
          {formatHour(segment.startHour)} – {formatHour(segment.endHour)}
        </span>

        {hovered && (
          <div className="schedule-block-toolbar" onMouseDown={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="schedule-block-toolbar-btn schedule-block-toolbar-btn--danger"
              onClick={() => onDeleteRequest(segment)}
            >
              Удалить
            </button>
          </div>
        )}
      </div>

      <div
        className="schedule-resize-handle schedule-resize-handle--bottom"
        title="Изменить конец"
        onMouseDown={(e) => onResizeStart(e, segment, 'resize-end')}
      />
    </div>
  );
};

export default ScheduleAvailabilityBlock;
